module.exports = __webpack_public_path__ + "static/media/animal.b0ae0636.JPG";